// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"M0-z","displaySixCardTiles":"N0-z"};